module.exports = __webpack_public_path__ + "img/testCode.8574496c.png";